import { render, staticRenderFns } from "./Poster.vue?vue&type=template&id=58f527cc&scoped=true"
import script from "./Poster.vue?vue&type=script&lang=js"
export * from "./Poster.vue?vue&type=script&lang=js"
import style0 from "./Poster.vue?vue&type=style&index=0&id=58f527cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f527cc",
  null
  
)

export default component.exports